import { useUserFormRole } from './useUserFormRole';
import { FORM_ROLES } from '../constants/roles';
import {
  AUTO_ADD_INFO_FOR,
  SUBMITTER_2_STRICT_ORDER_STEP,
} from '../components/from-builder/elements-settings/submitters-field-element-settings';

// For a form at the submission/initiation stage. `strictOrderStep` is the
// get-form's `strict_order_step`: "Submitter 2" binds only whoever submits at
// step 2 of a strict order, and nobody on a form without one (null).
export const useIsRequiredElement = (
  element,
  form_has_only_one_submitter = false,
  submitterType = undefined,
  strictOrderStep = undefined,
) => {
  const userFormRole = useUserFormRole();
  const { requiredFor } = element.options;

  if (form_has_only_one_submitter) {
    return !!requiredFor;
  }

  if (requiredFor === AUTO_ADD_INFO_FOR.SUBMITTER_2) {
    return userFormRole === FORM_ROLES.FORM_SUBMITTER && strictOrderStep === SUBMITTER_2_STRICT_ORDER_STEP;
  }

  return requiredFor !== undefined && (requiredFor === userFormRole || requiredFor === submitterType);
};
